import React from 'react'
import LeftStory from './LeftStory'
import { AttachedSentences } from 'utils/storySentences'
import { OccurrenceSense } from 'utils/wordSenses'

interface IStoryIntroProps {
  story?: any
  handleClickWord: any
  activeIndex: any
  chineseWordFontSize?: any
  showTranslate: boolean
  showEnglish?: boolean
  sentences?: AttachedSentences | null
  showPinYin: boolean
  wordSenses?: Map<string, OccurrenceSense> | null
}

const StoryContent: React.FC<IStoryIntroProps> = ({
  story,
  handleClickWord,
  activeIndex,
  chineseWordFontSize,
  showTranslate,
  showEnglish,
  sentences,
  showPinYin,
  wordSenses,
}) => {
  return (
    <>
      <LeftStory
        story={story}
        showPinYin={showPinYin}
        handleClickWord={handleClickWord}
        activeIndex={activeIndex}
        showTranslate={showTranslate}
        showEnglish={showEnglish}
        sentences={sentences}
        wordSenses={wordSenses}
        chineseWordFontSize={chineseWordFontSize}
      />
      {/* <NewWord
        story={story}
        handleClickWord={handleClickWord}
        activeIndex={activeIndex}
        chineseWordFontSize={chineseWordFontSize}
      /> */}
    </>
  )
}
export default StoryContent
